'use client';

import { PRODUCT_NAME } from '@/constants';
import { CommonFooter as CommonCommonFooter, type FooterMenuItem } from '@monorepo/common';
import type { Session } from 'next-auth';

function CommonFooter({
  siteName,
  sessionData,
}: {
  siteName: string;
  sessionData?: Session | null;
}) {
  // toはサイト内リンク、hrefは外部リンク
  const menuListLeft: Array<FooterMenuItem> = sessionData?.user
    ? [
        { to: '/auth/signin', text: 'ログイン・新規会員登録' },
        { to: '/lotteries?session=true', text: '開催中のくじ一覧' },
        { to: '/faq', text: 'よくある質問' },
        { to: '/contact', text: 'お問い合わせ' },
        { to: '/informations', text: 'お知らせ' },
      ]
    : [
        { to: '/auth/signin', text: 'ログイン・新規会員登録' },
        { to: '/lotteries?session=true', text: '開催中のくじ一覧' },
        { to: '/faq', text: 'よくある質問' },
        { to: '/informations', text: 'お知らせ' },
      ];

  const menuListRight: Array<FooterMenuItem> = [
    { to: '/terms', text: '利用規約' },
    {
      href: 'https://fogg.jp/privacy',
      text: '個人情報保護方針',
    },
    {
      to: '/policy',
      text: '個人情報の取扱いについて',
    },
    { to: '/tokusho', text: '特定商取引法に基づく表記' },
    { to: '/shikin', text: '資金決済法に基づく表記' },
    { to: '/keihin', text: '景品のお取り扱いについての注意事項' },
  ];

  const copyright = `Copyrights 2024 ${PRODUCT_NAME} All Rights Reserved.`;

  return (
    <CommonCommonFooter
      siteName={siteName}
      copyright={copyright}
      menuListLeft={menuListLeft}
      menuListRight={menuListRight}
    />
  );
}

export default CommonFooter;
